<template>
  <v-container class="home-page">
    <v-row class="text-center">
      <v-col cols="12">
        <v-row class="selection-outer-container my-12">
          <v-col
            cols="12"
            md="3"
            v-for="item in filteredItems"
            :key="item.title"
          >

            <v-card
              class="mx-auto v-btn selection-container"
              width="300"
              height="300"
              :to="{name: item.link}"
            >
              <div class="selection-body">
                <v-icon :style="{'font-size': '151px'}" class="mb-5">
                  {{ item.icon }}
                </v-icon>
                <p>{{ item.title }}</p>
              </div>
            </v-card>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import services from '../services';

const { authService } = services;

export default {
  name: 'HomePage',
  data() {
    return {
      alert: true,
      drawer: true,
      items: [
        {
          title: 'Registry', icon: 'mdi-heart-pulse', link: 'specimen-source.list', permission: 'medicalRegistry',
        },
        {
          title: 'Biobank', icon: 'mdi-flask-outline', link: 'specimen-state.list', permission: 'biobankRegistry',
        },
        {
          title: 'Collecting Institution', icon: 'mdi-domain', link: 'collecting-institution.list', permission: 'collectingInstitution',
        },
        {
          title: 'Documents', icon: 'mdi-file-document-outline', link: 'service-agreement.list', permission: 'documents',
        },
        {
          title: 'Control Panel', icon: 'mdi-security', link: 'user.list', permission: 'controlPanel',
        },
      ],
      mini: true,
    };
  },
  computed: {
    filteredItems() {
      const userModule = authService.getUserActiveModule();
      return this.items.filter(
        (i) => userModule.find((um) => i.permission === um),
      );
    },
  },
};
</script>
<style scoped>

.home-page {
  height: 100%;
  overflow: hidden auto;
  background: url(../assets/up-pgh-biobank.png) no-repeat 91% 91%;
  background-attachment: fixed;
  overflow: hidden;
}

.selection-container {
  position: relative;
  cursor: pointer;
}

.selection-body {
  margin: 0;
  position: absolute;
  top: 45%;
  left: 35%;
  -ms-transform: translateY(-45%) translateX(-24%);
  transform: translateY(-45%) translateX(-24%);
}

.selection-outer-container {
  padding-left: 10%;
  padding-right: 10%;
}

@media only screen and (max-width: 768px) {
  /* For mobile phones: */
  .selection-outer-container {
    padding-left: unset;
    padding-right: unset;
  }
}

</style>
